import {useEffect, useState} from "react";
import {useAuthContext} from "./useAuthContext";
import {auth} from "../../firebase/config";

const useLogout = () => {
    const [error, setError] = useState<string | null>(null)
    const [isPending, setIsPending] = useState<boolean>(false)
    const {dispatch} = useAuthContext();

    const logout = async  () => {
        setError(null);
        setIsPending(true);

        try {
            await auth.signOut();
            if(dispatch) {
                dispatch({type: 'LOGOUT', payload: null});
            }
            setIsPending(false);
            setError(null);

        } catch (e: any) {
            console.log(e);
            setError(e.message);
            setIsPending(false);
        }
    }

    return {
        logout,
        error,
        isPending,
    };
}

export default useLogout;